import { Observable } from '../observable/observable';
export const filter = predicate => source => new Observable(subscriber => {
  source.subscribe(value => {
    if (predicate(value)) {
      subscriber.next(value);
    }
  });
});